import { useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { LIGHTEST_BACKGROUND, SIDE_NAV_WIDTH } from "@/css/constants";

import { RoleplayAssignmentContainer } from "./RoleplayAssignmentContainer";

export function RoleplayAssignmentPage() {
  useHead({
    bodyAttrs: { style: { backgroundColor: LIGHTEST_BACKGROUND } },
  });

  return (
    <Authenticate maxWidth="100%" layout="full">
      <SEOHead title="Roleplays – Exec" />
      <Nav />
      <Box ml={[0, 0, SIDE_NAV_WIDTH]} pb={64}>
        <RoleplayAssignmentContainer />
      </Box>
    </Authenticate>
  );
}
